import {
  Component,
  OnInit,
  Inject,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import {
  FormControl,
  Validators,
  FormGroup,
  FormBuilder,
} from "@angular/forms";
import { MenuService } from "../../menu.service";
import { Subscription } from "rxjs";
import { MixinFunctionsService } from "src/app/pages/services/mixin-functions.service";

@Component({
  selector: "app-menu-dialog",
  templateUrl: "./menu-dialog.component.html",
  styleUrls: ["./menu-dialog.component.scss"],
})
export class MenuDialogComponent implements OnInit {
  saveFunction = new EventEmitter();

  parentMenus: any;
  private form: FormBuilder;
  subs: Subscription[] = [];

  constructor(
    public dialogRef: MatDialogRef<MenuDialogComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public formData,
    private menus: MenuService,
    public mixins: MixinFunctionsService
  ) {}

  ngOnInit(): void {}

  save() {
    if (this.formData.hasSubMenu && !this.formData.parentId) {
      this.formData.parentId = 0;
    }
    //console.log('fm', this.formData)
    this.saveFunction.emit(this.formData);
  }
  closeDialog() {
    this.dialogRef.close();
    this.formData = {};
  }
  initFormGroup(): FormGroup {
    return this.form.group({
      routerLink: ["", Validators.required],
      icon: ["", Validators.required],
      title: ["", Validators.required],
    });
  }
  get title() {
    if (this.formData.id) {
      return "Update";
    } else {
      return "Add";
    }
  }
  get orders() {
    return [...Array(101).keys()].filter((number) => number !== 0);
  }
}
